export default __webpack_public_path__ + "images/e029a98075967c92586b619fcb4334c3-illustration-eui-hero-500-darkmode-shadow.svg";